import React from 'react';

import { Skeleton } from '@material-ui/lab';

import { BaseSkeletonProps } from './BaseSkeleton.types';

const BaseSkeleton: React.FC<BaseSkeletonProps> = ({ width, height, className, variant }) => {
  return (
    <Skeleton
      variant={variant}
      width={width ?? 200}
      height={height ?? 20}
      className={`${variant !== 'circle' ?? `br1`} ${className}`}
    />
  );
};

BaseSkeleton.defaultProps = {
  variant: "text"
};

export default BaseSkeleton;
export { BaseSkeletonProps };
